interface PadlockIllustrationProps {
  className?: string;
}

export const PadlockIllustration = ({ className }: PadlockIllustrationProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="132"
      height="202"
      viewBox="0 0 132 202"
      fill="none"
      className={className}
    >
      <path
        d="M130.683 108.632C130.766 140.088 108.655 178.379 81.2751 194.19C67.276 202.301 54.5948 202.919 45.5366 197.36C45.4954 197.36 45.413 197.319 45.3718 197.278L15.8917 180.15C6.99836 174.962 1.48101 163.969 1.4398 148.364L1.31641 108.22L22.85 95.7855L38.2076 86.9331L89.8802 57.1236L105.197 53.7886L130.519 68.4875H130.56V68.5287L130.683 108.632Z"
        fill="#4C99A4"
        stroke="#041823"
      />
      <path
        d="M1.32227 108.233L31.4204 125.728L31.5338 165.845C31.5904 181.477 37.1029 192.465 45.9948 197.637L15.8779 180.143C6.98592 174.97 1.47333 163.983 1.43553 148.351L1.32227 108.233Z"
        fill="#30839D"
        stroke="#041823"
      />
      <path
        d="M130.549 68.5185L31.4261 125.732L1.32227 108.235L22.8671 95.7973L38.2142 86.9434L89.8629 57.1347L105.21 53.8037L130.549 68.5185Z"
        fill="#5CC3C9"
        stroke="#041823"
      />
      <path
        d="M130.552 68.4922L130.665 108.617C130.755 140.071 108.636 178.381 81.263 194.185C53.8896 209.989 31.6268 197.302 31.5376 165.848L31.4238 125.724L130.552 68.4922Z"
        fill="#51A6B1"
        stroke="#041823"
      />
      <path
        d="M88.2992 142.946C91.1454 138.831 92.9916 133.831 92.9916 129.446C92.9531 123.946 90.1839 120.907 86.1836 120.984C85.9145 120.984 85.6453 121.023 85.376 121.061C86.6836 122.484 87.4144 124.677 87.4529 127.523C87.4529 131.908 85.6453 136.908 82.7988 141.023L85.9145 156.293L85.9061 156.298L91.4494 158.199L88.2992 142.946Z"
        fill="#0A6190"
        stroke="#041823"
      />
      <path
        d="M85.9065 156.298L71.6836 164.486L71.2604 167.179L70.7988 170.102L91.4534 158.217L91.4498 158.199L85.9065 156.298Z"
        fill="#0A6190"
        stroke="#041823"
      />
      <path
        d="M82.7982 141.024C85.6447 136.908 87.4523 131.908 87.4523 127.523C87.4138 124.677 86.683 122.485 85.3754 121.062C84.0291 121.216 82.5292 121.754 81.0291 122.6C74.4519 126.408 69.1055 135.562 69.1055 143.178C69.144 147.601 70.9903 150.486 73.7981 151.332L71.6826 164.486L85.914 156.294L82.7982 141.024Z"
        fill="#041823"
        stroke="#041823"
      />
      <path
        d="M98.4655 79.4705C94.5344 79.4705 90.8015 78.565 87.9559 76.9231C84.7739 75.0849 83.0193 72.5338 83.0156 69.7355C83.012 66.9645 84.7303 64.4389 87.8522 62.6243C90.6833 60.9787 94.4125 60.0732 98.3564 60.0732C102.297 60.0732 106.035 60.9769 108.879 62.6188C112.048 64.4498 113.795 66.9936 113.799 69.7846C113.803 72.5648 112.073 75.1031 108.928 76.9286C106.109 78.5687 102.393 79.4705 98.4655 79.4705Z"
        fill="#51A6B1"
        stroke="#041823"
      />
      <path
        d="M107.95 64.2335C113.255 67.2967 113.265 72.2579 107.994 75.3212C102.741 78.3742 94.1935 78.3743 88.8878 75.311C83.582 72.2477 83.5363 67.2866 88.7899 64.2335C94.0611 61.1702 102.644 61.1702 107.95 64.2335Z"
        fill="#0A6190"
        stroke="#041823"
      />
      <path
        d="M32.3346 116.774C28.4035 116.774 24.6706 115.869 21.825 114.227C18.643 112.389 16.8884 109.838 16.8848 107.039C16.8811 104.268 18.5994 101.743 21.7214 99.928C24.5524 98.2825 28.2817 97.377 32.2255 97.377C36.1657 97.377 39.9041 98.2806 42.7478 99.9225C45.9171 101.754 47.6644 104.297 47.6681 107.088C47.6717 109.868 45.9425 112.407 42.7969 114.232C39.9786 115.872 36.2621 116.774 32.3346 116.774Z"
        fill="#51A6B1"
        stroke="#041823"
      />
      <path
        d="M41.8168 101.536C47.1225 104.599 47.1326 109.56 41.8614 112.623C36.6079 115.676 28.0607 115.677 22.755 112.613C17.4492 109.55 17.4035 104.589 22.6571 101.536C27.9283 98.4725 36.511 98.4724 41.8168 101.536Z"
        fill="#0A6190"
        stroke="#041823"
      />
      <path
        d="M109.176 65.0325V74.5024C108.805 74.7906 108.435 75.0788 107.982 75.3259C102.753 78.3727 94.1888 78.3727 88.8776 75.3259C88.5069 75.1201 88.2186 74.914 87.8894 74.667L87.8482 67.4616V35.1406C87.7597 22.321 81.5544 19.0215 70.6378 25.3825C55.5681 34.1113 42.8869 56.0568 42.9279 73.3084V111.888C42.5987 112.176 42.228 112.423 41.8576 112.629C36.6285 115.676 28.0643 115.676 22.7531 112.629C22.3412 112.382 21.9708 112.135 21.6413 111.888V73.3496C21.5179 48.6456 38.2753 19.4123 59.9325 6.93689C84.611 -7.3551 109.006 4.97987 109.094 35.0994L109.176 65.0325Z"
        fill="#F5F6F6"
        stroke="#041823"
      />
    </svg>
  );
};
